'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AnyValidator = exports.AnyRule = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _validator = require('validator');

var _validator2 = _interopRequireDefault(_validator);

var _helpers = require('../helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/****************************************
  Rule Builder
*****************************************/

var AnyRule = function () {

  /**
   * Utilities
   */

  function AnyRule(rules) {
    _classCallCheck(this, AnyRule);

    this.rules = rules || {};
  }

  _createClass(AnyRule, [{
    key: 'setRule',
    value: function setRule(ruleName, rule) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      if (typeof ruleName !== 'string') throw new Error('`ruleName` argument should be a string');
      return new AnyRule(Object.assign({}, this.toJSON(), _defineProperty({}, ruleName, !Object.keys(options).length ? rule : Object.assign({}, options, { rule: rule }))));
    }
  }, {
    key: 'getRule',
    value: function getRule(ruleName) {
      return this.rules[ruleName];
    }
  }, {
    key: 'removeRule',
    value: function removeRule(ruleName) {
      delete this.rules[ruleName];
      return this;
    }
  }, {
    key: 'toJSON',
    value: function toJSON() {
      return this.rules;
    }

    /**
     * Error Customizations
     */

    // Use a "catch-all" message that overrides all other messages

  }, {
    key: 'message',
    value: function message(_message) {
      if (typeof _message !== 'string') throw new Error('`message` should be a string');
      return this.setRule('message', _message);
    }

    // Custom Labels

  }, {
    key: 'label',
    value: function label(_label) {
      if (typeof _label !== 'string') throw new Error('`label` should be a string');
      return this.setRule('label', _label);
    }

    /**
     * Rules
     */

  }, {
    key: 'custom',
    value: function custom(cb) {
      return this.setRule('custom', cb);
    }
  }, {
    key: 'required',
    value: function required(message) {
      return this.setRule('required', true, (0, _helpers.cleanObject)({ message: message }));
    }
  }, {
    key: 'optional',
    value: function optional() {
      this.removeRule('required');
      return this;
    }
  }, {
    key: 'in',
    value: function _in(possible, message) {
      if (!Array.isArray(possible)) throw new Error('`possible` must be an array');
      return this.setRule('in', possible, (0, _helpers.cleanObject)({ message: message }));
    }
  }]);

  return AnyRule;
}();

/****************************************
  Validator
*****************************************/

var AnyValidator = function () {

  /**
   * Utilities
   */

  function AnyValidator(rules) {
    _classCallCheck(this, AnyValidator);

    this.rules = rules.toJSON() || {};
  }

  _createClass(AnyValidator, [{
    key: 'check',
    value: function check(key, value) {

      // Collect errors
      var errors = [];

      // Check requiredness before all other rules. Failing required-ness means no other
      // validation is nessesary
      var requiredErrorMessage = this.checkRule(value, 'required');
      if (requiredErrorMessage) return this.formatErrorMessage(key, value, requiredErrorMessage);

      // If a value is required and empty, the code will not get to this point. When a value
      // is not required and it's empty, we will return without error and without doing
      // other checks
      if ((0, _helpers.isEmpty)(value)) return;

      // Check Type. Failing type means no other validation is nessesary
      var typeErrorMessage = this.checkRule(value, 'type');
      if (typeErrorMessage) return this.formatErrorMessage(key, value, typeErrorMessage);

      // Check everything else
      var err = void 0;
      for (var ruleName in this.rules) {

        // Already checked
        if (ruleName !== 'required' && ruleName !== 'type') {
          err = this.checkRule(value, ruleName);
          if (err) errors.push(err);
        }
      }

      // Only return errors if some were found
      if (errors.length) return this.formatErrorMessage(key, value, errors);
    }
  }, {
    key: 'checkRule',
    value: function checkRule(value, ruleName) {

      // Establish rule, message, and options
      if (_lodash2.default.get(this, 'rules.' + ruleName + '.rule')) {
        var _rules$ruleName = this.rules[ruleName],
            rule = _rules$ruleName.rule,
            message = _rules$ruleName.message,
            options = _objectWithoutProperties(_rules$ruleName, ['rule', 'message']);
      } else {
        var rule = this.rules[ruleName];
        var message = null;
        var options = {};
      }

      // If the validation function exists, validate
      if (typeof this[ruleName] === 'function') {
        var errorMessage = this[ruleName](value, rule, options);
        return errorMessage ? message || errorMessage : null;
      } else {
        return null;
      }
    }
  }, {
    key: 'formatErrorMessage',
    value: function formatErrorMessage(key, value, errors) {
      errors = Array.isArray(errors) ? errors : [errors];
      return {
        label: this.rules.label || (0, _helpers.camelToLabel)(key),
        value: value,

        // Use overriding message if one was provided
        errors: this.rules.message ? [this.rules.message] : errors
      };
    }

    /**
     * Validate Rules
     */

  }, {
    key: 'custom',
    value: function custom(value, cb) {
      var err = cb(value);
      return typeof err === 'string' ? err : '';
    }
  }, {
    key: 'required',
    value: function required(value, _required) {
      return _required && (0, _helpers.isEmpty)(value) ? 'Is required' : '';
    }
  }, {
    key: 'in',
    value: function _in(value, possible) {
      var found = possible.findIndex(function (item) {
        if (item === value) return true;
        if (item + '' === value + '') return true;
      });
      return found > -1 ? '' : 'Does not match possible values';
    }
  }]);

  return AnyValidator;
}();

exports.AnyRule = AnyRule;
exports.AnyValidator = AnyValidator;